import*as React from"react";import{readableColor}from"polished";import styled from"../styled-components";import{UniversalLink}from"../components/UniversalLink/UniversalLink";const StyledButton=styled(UniversalLink)`
  display: inline-block;
  padding: ${a=>a.small?"0.8em":"1em 1.5em"};
  text-align: center;

  font-weight: ${a=>a.theme.components.buttons.fontWeight};
  border-radius: ${({theme:a})=>a.components.buttons.borderRadius};
  font-family: ${({theme:a})=>a.components.buttons.fontFamily};

  box-shadow: ${a=>a.theme.components.buttons.boxShadow};
  text-decoration: none;
  transition: all 0.1s ease;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  cursor: pointer;

  &&::after {
    content: none;
  }

  & + & {
    margin-left: 0.625em;
  }

  :active {
    color: ${({inversed:a,theme:b,transparent:c,color:d})=>a?d&&readableColor(d)||b.colors.primary.contrastText:c?d&&readableColor(d)||b.colors.primary.contrastText:d||b.colors.primary.main} !important;
    background-color: ${({transparent:a,inversed:b,theme:c,color:d})=>a?d||c.colors.primary.main:b?d||c.colors.primary.main:d&&readableColor(d)||c.colors.primary.contrastText};
    border-color: ${({theme:a,color:b})=>b||a.colors.primary.main};
  }

  color: ${({inversed:a,transparent:b,theme:c,color:d})=>a&&b?d&&readableColor(d)||c.colors.primary.contrastText:b||a?d||c.colors.primary.main:d&&readableColor(d)||c.colors.primary.contrastText} !important;
  background-color: ${({transparent:a,inversed:b,theme:c,color:d})=>a?"transparent":b?d&&readableColor(d)||c.colors.primary.contrastText:d||c.colors.primary.main};
  border: ${a=>a.small?"1px":"2px"} solid;
  border-color: ${({inversed:a,theme:b,color:c})=>a?c&&readableColor(c)||b.colors.primary.contrastText:c||b.colors.primary.main};
  min-width: ${a=>a.large?"248px":"auto"};

  @media only screen and (max-width: ${({theme:a})=>a.breakpoints.medium}) {
    min-width: auto;
  }

  :hover {
    box-shadow: ${a=>a.theme.components.buttons.hoverBoxShadow};
    ${({theme:a})=>a.components.buttons.hoverStyle}
  }
`,StyledButtonAsButton=StyledButton.withComponent("button");export function Button(a){return a.to?React.createElement(StyledButton,Object.assign({},a)):React.createElement(StyledButtonAsButton,Object.assign({},a))}